/** Warp circles to other zones: blue rune rings turning and a column of light. */
import { ellipse } from '../drawKit';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'portals',
  layer: 'ground',
  order: 200,
  draw({ g, world: w, iso, ox, oy, W, H }) {
    const t = w.time;
    g.lineWidth = 1;
    for (const P of w.map.portals) {
      const [px, py] = iso.proj(P.x, P.y);
      const x = px + ox;
      const y = py + oy;
      // Off the world picture (rings ±30 wide, light column 90 up): nothing to draw. The map's other circles
      // each cost a gradient, a stroked ring set and a star every frame.
      if (x < -32 || x > W + 32 || y < -17 || y > H + 92) continue;
      const pulse = 0.5 + 0.5 * Math.sin(t * 3);
      g.fillStyle = `rgba(90,170,255,${0.18 + 0.1 * pulse})`;
      ellipse(g, x, y, 30, 15);
      g.fill();
      g.lineWidth = 1;
      for (const [r, spin, n] of [
        [30, t * 0.6, 12],
        [22, -t * 0.9, 8],
        [13, t * 1.4, 6],
      ] as const) {
        g.strokeStyle = `rgba(150,210,255,${0.6 + 0.3 * pulse})`;
        ellipse(g, x, y, r, r / 2);
        g.stroke();
        g.fillStyle = 'rgba(230,245,255,.95)';
        for (let k = 0; k < n; k++) {
          const a = spin + (k / n) * Math.PI * 2;
          g.fillRect(Math.round(x + Math.cos(a) * r) - 1, Math.round(y + (Math.sin(a) * r) / 2), 2, 2);
        }
      }
      // Six-pointed rune star inside.
      g.strokeStyle = `rgba(190,230,255,${0.55 + 0.25 * pulse})`;
      for (const off of [0, Math.PI / 3]) {
        g.beginPath();
        for (let k = 0; k <= 3; k++) {
          const a = t * 0.4 + off + (k / 3) * Math.PI * 2;
          const [qx, qy] = [x + Math.cos(a) * 20, y + (Math.sin(a) * 20) / 2];
          if (k) g.lineTo(qx, qy);
          else g.moveTo(qx, qy);
        }
        g.stroke();
      }
      const colH = 90;
      const gr = g.createLinearGradient(0, y - colH, 0, y);
      gr.addColorStop(0, 'rgba(120,200,255,0)');
      gr.addColorStop(1, `rgba(120,200,255,${0.28 + 0.12 * pulse})`);
      g.fillStyle = gr;
      g.fillRect(Math.round(x - 14), y - colH, 28, colH);
    }
  },
});
